import { InputNumber } from "antd";
import "./styles.css";

export const NumberInputBox = ({
  placeholder,
  value,
  onChange,
  required,
  size,
  ...props
}) => {
  return (
    <InputNumber
      className="input-box-number w-full sm:w-2/5 md:w-4/5"
      placeholder={placeholder}
      value={value}
      onChange={(value) => {
        onChange(value);
      }}
      required={required}
      {...props}
    />
  );
};
